export function spread(...operations) {
    return (source) => operations.reduce((acc, operator) => acc.pipe(operator), source);
}
//# sourceMappingURL=spread.js.map